import './assets/main.css';

import { createApp, type App as VueApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import router from './router';
import { createPinia } from 'pinia';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { getBasePath } from './common/api/basePathApi';
import { TILogTheme } from 'shared/themes/tilog';
import { SILogTheme } from 'shared/themes/silog';
import { getTheme } from 'shared/themes/api/themeApi';
import { useThemeStore } from 'shared/themes/stores/themeStore';

async function initializeApp() {
  const basePath = await getBasePath();

  const head = document.querySelector('head');
  if (head) {
    const baseElement = document.createElement('base');
    baseElement.href = basePath;
    head.appendChild(baseElement);
  }

  const pinia = createPinia();
  const app = createApp(App);

  app.use(pinia);
  await usePrimevue(app);
  app.use(ConfirmationService);
  app.use(ToastService);

  // Initialize router with dynamic base path (after Pinia and PrimeVue)
  const routerInstance = router(basePath);
  app.use(routerInstance);
  app.directive('tooltip', Tooltip);

  app.mount('#app');
}

async function usePrimevue(app: VueApp<Element>) {
  let themeSetting = null;
  themeSetting = await getTheme();

  const theme = themeSetting != null && themeSetting == 'TILog' ? TILogTheme : SILogTheme;

  const themeStore = useThemeStore();
  if (themeSetting != null) {
    themeStore.setTheme(themeSetting);
  }

  app.use(PrimeVue, {
    theme: {
      preset: theme,
      ripple: true,
      options: {
        darkModeSelector: '.p-dark',
      },
    },
  });
}

// Initialize the app
initializeApp();
